export default __webpack_public_path__ + "static/media/Leggings of the Strange Beyond.3f2a4104.jpg";